import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { UserClientFormChat } from '@/widgets/mastra-chat'

const searchSchemaValidation = z.object({
  verificationId: z.string().min(1),
})

export const Route = createFileRoute('/_public-forms/forms/chat/$id')({
  validateSearch: (search) => searchSchemaValidation.parse(search),
  component: RouteComponent,
  search: {
    middlewares: [
      ({ search, next }) => {
        const result = next(search)
        const { verificationId: _, ...otherParams } = result
        return {
          verificationId: search.verificationId ?? result.verificationId,
          ...otherParams,
        }
      },
    ],
  },
})

export const FormChatRoute = Route

function RouteComponent() {
  const { id } = FormChatRoute.useParams()
  const { verificationId } = FormChatRoute.useSearch()

  return <UserClientFormChat verificationId={verificationId} formId={id} />
}
